import { SortingState, Updater, VisibilityState } from '@tanstack/react-table';
import { AlertsTable } from './components/AlertsTable';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const useAdminAlertsTableStore = create(
  persist(
    () => {
      const state: {
        filters: VisibilityState;
        sorting: SortingState;
      } = {
        filters: {
          actionedAt: false,
          actionedBy: false,
          slaDue: false,
          duration: false,
        },
        sorting: [{ id: 'occurred', desc: true }],
      };
      return state;
    },
    {
      name: 'admin-alerts-table',
      storage: createJSONStorage(() => localStorage),
      version: 2
    }
  )
);

export default function AdminAlerts() {
  const columnVisibility = useAdminAlertsTableStore((s) => s.filters);
  const sorting = useAdminAlertsTableStore((s) => s.sorting);

  const onColumnVisibilityChange = (updater: Updater<VisibilityState>) => {
    useAdminAlertsTableStore.setState({
      filters:
        typeof updater === 'function'
          ? updater(useAdminAlertsTableStore.getState().filters)
          : updater,
    });
  };

  const onSortingChange = (updater: Updater<SortingState>) => {
    useAdminAlertsTableStore.setState({
      sorting:
        typeof updater === 'function'
          ? updater(useAdminAlertsTableStore.getState().sorting)
          : updater,
    });
  };

  return (
    <div className="flex flex-col">
      <AlertsTable
        admin
        columnVisibility={columnVisibility}
        sorting={sorting}
        onColumnVisibilityChange={onColumnVisibilityChange}
        onSortingChange={onSortingChange}
        showColumnToggle
        showProjectFilter
      />
    </div>
  );
}
